<template>
  <div class="mb-4">
    <v-card-title class="px-0 pb-1">Фильтр</v-card-title>
    <v-card>
      <v-card-text>
        <filter-template :enable="$vuetify.breakpoint.mobile" class="row flex-column flex-lg-row">
          <template #top>
            <v-col>
              <custom-input-text
                  hide-details
                  clearable
                  label="Ф.И.О"
                  v-model="filter.name"
              ></custom-input-text>
            </v-col>
          </template>
          <template #body>
            <v-col>
              <custom-input-text
                  clearable
                  hide-details
                  always-uppercase
                  v-mask="'AA#######'"
                  label="Паспорт серия и номер"
                  v-model="filter.passport"
              ></custom-input-text>
            </v-col>
            <v-col>
              <custom-select
                  :items="DEBT_STATUS"
                  clearable
                  hide-details
                  item-text="text"
                  item-value="value"
                  label="Задолженность"
                  v-model="filter.debts"
              ></custom-select>
            </v-col>
            <v-col class="d-flex ma-n2 flex-shrink-0">
              <div class="pa-2" style="min-width: 120px">
                <custom-date-picker
                    hide-details
                    clearable
                    label="Дата от"
                    v-model="filter.from"
                ></custom-date-picker>
              </div>
              <div class="pa-2" style="min-width: 125px">
                <custom-date-picker
                    hide-details
                    clearable
                    label="Дата до"
                    v-model="filter.to"
                ></custom-date-picker>
              </div>
            </v-col>
          </template>
          <template #footer>
            <div class="col d-flex ma-n1 flex-column flex-lg-row">
              <div class="pa-1">
                <v-btn @click="clear" color="error"
                       width="100%" style="min-width: auto">
                  <v-icon>fas fa-times</v-icon>
                </v-btn>
              </div>
              <div class="pa-1">
                <v-btn width="100%" @click="filterList"
                       color="primary"
                       style="min-width: auto">
                  <v-icon>fas fa-search</v-icon>
                </v-btn>
              </div>
              <div class="pa-1">
                <download-excel-debtor
                    width="100%" :filter="filter"/>
              </div>
            </div>
          </template>
        </filter-template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {CREDIT_STATUS, DEBT_STATUS} from "@/utils/constants";
import FilterTemplate from "@/components/ui/template-filter/TemplateFIlter";
import DownloadExcelCredits from "@/components/credit/DonwloadExcelCreditsList";
import DownloadExcelDebtor from "@/components/debtor/DonwloadExcelDebtorList";

export default {
  name: 'debtor-table-filter',
  components: {DownloadExcelDebtor, FilterTemplate},
  props: {
    mkos: {
      type: Array
    },
    filter: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      showingFilter: false,
      status: CREDIT_STATUS,
      DEBT_STATUS,
    }
  },
  methods: {
    filterList() {
      this.$emit('change', this.filter)
    },
    clear() {
      const filter = {
        name: null,
        from: null,
        to: null,
      }
      this.$emit('update:filter', filter)
      this.$emit('change', this.filter)
    }
  }
}
</script>
